import { useMemo } from 'react';

function StyleOverride({ style, id }: { style?: string; id?: string }) {
  const innerHTML = useMemo(
    () => ({
      __html: style || '',
    }),
    [style],
  );
  // skip rendering when there is no style to inject — otherwise the empty
  // <style> slot collides with emotion's useServerInsertedHTML output during
  // hydration and causes an attribute mismatch
  if (!style) return null;
  // biome-ignore lint/security/noDangerouslySetInnerHtml: style injection is safe
  return <style dangerouslySetInnerHTML={innerHTML} id={id} />;
}

export default StyleOverride;
